export default __webpack_public_path__ + "static/media/pinterest.157c11ea.svg";